Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = airEventToJitneyEvent;

var _logging_context_v = require('airbnb-jitney-schemas/logging_context_v2');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function filterObj(object, fields) {
  return fields.reduce(function (memo, field) {
    return Object.assign({}, memo, _defineProperty({}, field, object[field]));
  }, {});
}

// Reshapes airEvent by moving tracking-js fields to context, combines with
// actual event data
function airEventToJitneyEvent(airEvent, schema, jitneyEventData) {
  var eventData = airEvent.event_data;
  var dimensions = eventData.dimensions;

  var _ref = dimensions || { height: -1, width: -1 },
      height = _ref.height,
      width = _ref.width;

  // affiliate_id is named as affiliate in airEvent


  eventData.affiliate_id = eventData.affiliate;

  return Object.assign({}, airEvent, {
    event_data: Object.assign({
      context: Object.assign({}, filterObj(eventData, Object.keys(_logging_context_v.Context.propTypes)), {
        web: filterObj(eventData, Object.keys(_logging_context_v.WebContext.propTypes)),
        screen_height: height,
        screen_width: width
      })
    }, schema.defaultProps, jitneyEventData)
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-tracking/build/jitney/airEventToJitneyEvent.js
// module id = 476
// module chunks = 168707334958949